function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M17.2 14.2H6.7c-.4 0-.7.4-.7.8s.3.7.7.7h10.5c.4 0 .7-.3.7-.7.1-.4-.2-.8-.7-.8zm0 3.8H6.7c-.4 0-.7.3-.7.7 0 .4.3.7.7.7h10.5c.4 0 .7-.3.7-.7.1-.4-.2-.7-.7-.7zm2.3-15h-2.2V1.5h-2C14.6.6 13.4 0 12 0S9.4.6 8.8 1.5h-2V3H4.5c-1.7 0-3 1.3-3 3v15c0 1.7 1.3 3 3 3h15c1.7 0 3-1.3 3-3V6c0-1.7-1.3-3-3-3zM8.2 3h1.7c0-.8.9-1.5 2.1-1.5s2.1.7 2.1 1.5h1.7v3H8.2V3zM21 21c0 .8-.7 1.5-1.5 1.5h-15c-.8 0-1.5-.7-1.5-1.5V6c0-.8.7-1.5 1.5-1.5h2.2v3h10.5v-3h2.2c.9 0 1.6.7 1.6 1.5v15zm-3.8-10.5H6.7c-.4 0-.7.3-.7.7 0 .5.3.8.7.8h10.5c.4 0 .7-.3.7-.7.1-.5-.2-.8-.7-.8z"
});

function SvgQuoteIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default SvgQuoteIcon;